// ◉ xlVISION · Powering Business Together!
// © ExcelVision, Lda. — Braga, Portugal
// ( ·:·●●·:· ) xlVISION | Powering Business Together!
//
// ============================================================================
// A JANELA DO MAPA — D-101 · o mapa contínuo (2026-10-22)
// ============================================================================
//
// 📗 Cliente, 2026-10-22: *«quando for 2027 o que vai acontecer?»* → *«mapa contínuo»*. O mapa e
//    as escritas contavam os dias desde 1 de Janeiro de UM ano (`ANO_MAPA`); a 1 de Janeiro do ano
//    seguinte o mapa ficava no ano antigo e uma viagem de 28/12 a 3/1 não tinha onde existir.
//
// 📌 **O índice continua a ser «o dia número N»** — as contas entre dias (mais de 3 000 sítios)
//    ficam como estão. O que muda é a ORIGEM: o dia 0 é o `inicio` da janela, e não 1 de Janeiro.
//    Todas as conversões índice ↔ data passam por AQUI; uma segunda fórmula divergiria.
//
// ⚠️ `janelaDoAno` existe para a transição (fase 1a do plano): troca-se «ano» por «janela» em todo o
//    sistema com a janela igual ao ano — comportamento idêntico, provado pelas provas que já existem —
//    e só depois a janela passa a contínua (`janelaContinua`).
// ============================================================================
const DIA = 86_400_000;
const utc = (iso) => Date.parse(`${iso}T00:00:00Z`);
const iso = (ms) => new Date(ms).toISOString().slice(0, 10);
/**
 * A janela que um objecto já descreve — o `DadosMapa` traz `inicio` e `nDias`, logo É a janela do
 * mapa que foi servido. Copia só os dois campos, para o nome dizer o que se passa.
 */
export function janelaDe(x) {
    return { inicio: x.inicio, nDias: x.nDias };
}
/** A janela de um ano civil inteiro — 1 de Janeiro, 365 ou 366 dias. */
export function janelaDoAno(ano) {
    return {
        inicio: `${String(ano).padStart(4, '0')}-01-01`,
        nDias: Math.round((Date.UTC(ano + 1, 0, 1) - Date.UTC(ano, 0, 1)) / DIA),
    };
}
/** Soma meses a uma data, ao dia 1 desse mês (as bordas da fita caem em inícios de mês). */
function inicioDoMes(isoData, meses) {
    const d = new Date(utc(isoData));
    return Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + meses, 1);
}
/**
 * A fita de D-101: de `mesesAtras` antes do mês de `hoje` até ao fim do mês `mesesAFrente` depois.
 * ⚠️ Bordas em início de mês, para os cabeçalhos dos meses começarem inteiros.
 */
export function janelaContinua(hoje, mesesAtras = 3, mesesAFrente = 15) {
    return janelaQueComecaEm(iso(inicioDoMes(hoje, -mesesAtras)), mesesAtras + mesesAFrente + 1);
}
/** Os meses de uma fita: 3 para trás, o do centro e 15 para a frente — o tamanho é SEMPRE este. */
export const MESES_DA_FITA = 19;
/**
 * 🔴 D-101 · «Ir para…» · A fita de `meses` meses que começa em `inicio`. `null` se `inicio` não é o
 * dia 1 de um mês válido — só essas fitas existem (as bordas caem em inícios de mês, e o tamanho é
 * fixo para o envio ter sempre o mesmo peso).
 */
export function janelaQueComecaEm(inicio, meses = MESES_DA_FITA) {
    if (!/^\d{4}-\d{2}-01$/.test(inicio))
        return null;
    const ini = utc(inicio);
    if (Number.isNaN(ini) || iso(ini) !== inicio)
        return null;
    const fim = inicioDoMes(inicio, meses);
    return { inicio, nDias: Math.round((fim - ini) / DIA) };
}
/** 🔴 D-101 · O início de uma fita deslocado `meses` meses (negativo = para trás), sempre num dia 1. */
export function inicioDeslocado(inicio, meses) {
    return iso(inicioDoMes(inicio, meses));
}
/** 🔴 D-101 · O início da fita que põe `data` com 3 meses para trás — a mesma conta da abertura. */
export function inicioDaFitaCentradaEm(data, mesesAtras = 3) {
    return iso(inicioDoMes(data.slice(0, 10), -mesesAtras));
}
/** O índice → `AAAA-MM-DD`. ⚠️ Em UTC, para não haver saltos de fuso. */
export function dataDoIndice(j, dia) {
    return iso(utc(j.inicio) + dia * DIA);
}
/** O índice → o `Date` da meia-noite UTC desse dia (para `getUTCDay`, `getUTCDate`…). ⚠️ Em UTC. */
export function dataUtcDoIndice(j, dia) {
    return new Date(utc(j.inicio) + dia * DIA);
}
/** `AAAA-MM-DD` → o índice na janela. ⚠️ Pode sair fora (negativo, ou ≥ `nDias`): ver `dentroDaJanela`. */
export function indiceDaData(j, isoData) {
    return Math.round((utc(isoData.slice(0, 10)) - utc(j.inicio)) / DIA);
}
/** O índice cai dentro da janela? */
export function dentroDaJanela(j, dia) {
    return Number.isInteger(dia) && dia >= 0 && dia < j.nDias;
}
/** O dia 0 da janela em milissegundos UTC — para as contas que já trabalham em `ms`. */
export function inicioEmMs(j) {
    return utc(j.inicio);
}
/** O último dia da janela, em data. */
export function fimDaJanela(j) {
    return dataDoIndice(j, j.nDias - 1);
}
//# sourceMappingURL=janela-do-mapa.js.map